import React from "react";

const ListGroup = ({
  items,
  selectedItem,
  onItemSelect,
  itemProperty,
  textProperty,
}) => {
  return (
    <div className="btn-group" role="group" aria-label="List">
      {items.map((item) => (
        <button
          key={item[itemProperty]}
          type="button"
          className={
            item.id === selectedItem.id
              ? "btn btn-primary rounded mx-1"
              : "btn btn-outline-primary rounded mx-1"
          }
          onClick={() => onItemSelect(item)}
        >
          <i className={`bx bx-${item[itemProperty]}-alt`}></i>{" "}
          {item[textProperty]}
        </button>
      ))}
    </div>
  );
};

ListGroup.defaultProps = {
  itemProperty: "id",
  textProperty: "name",
};

export default ListGroup;

/*
    <ul className="list-group list-group-horizontal">
      {items.map((item) => (
        <li
          key={item[itemProperty]}
          className={
            item.id === selectedItem.id
              ? "clickable list-group-item active"
              : "clickable list-group-item"
          }
          onClick={() => onItemSelect(item)}
        >
          {item[textProperty]}
        </li>
      ))}
    </ul>
*/
